// extracted by mini-css-extract-plugin
export default {"container":"ResetPass_container__3pviY","nort":"ResetPass_nort__PRa0W"};